import { CourierDto, CourierListItemDto, KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { createPath, Paths, ProjectPathParams } from '../../../../app/router/app.router';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../ui/components/pure/list-table-wrappers/infinite-table.component';
import { IncompleteCouriersControlsState } from '../logic/incomplete-couriers-props.map';
import { useIncompleteCouriersTable } from '../hooks/use-incomplete-couriers-table.hook';

type IncompleteCouriersTableProps = {
  params: ProjectPathParams<Paths.incompleteCouriers>;
  pages: PaginatedRow<CourierDto>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: Partial<IncompleteCouriersControlsState>) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  hasError: boolean;
  customMessage: string;
  onCompleteRegistration(row: CourierListItemDto): void;
  onDeactivate(row: CourierListItemDto): void;
};

export function IncompleteCouriersTable({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError,
  customMessage,
  onCompleteRegistration,
  onDeactivate
}: IncompleteCouriersTableProps) {
  const tb = useIncompleteCouriersTable(onCompleteRegistration, onDeactivate);

  const mapRowURL = useCallback(
    (row: CourierDto) =>
      createPath(Paths.courier, {
        projectID: params.shortcode || params.projectID,
        courierID: row.id
      }),
    [params.projectID, params.shortcode]
  );
  tb.config({ mapRowURL });

  return (
    <InfiniteTable
      uniqueKey="id"
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
      hasError={hasError}
      customMessage={customMessage}
    />
  );
}
